import { c as _c } from "react/compiler-runtime";
import { IcoClose16, IcoInfo16, IcoWarning16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import { AnimatePresence, motion } from 'framer-motion';
import type { Banner } from '../../error-warning-list';
type ErrorWarningSheetProps = {
  errors: Banner[];
  open: (nodeId: string) => void;
  isOpen: boolean;
};
const TEXT_COLOR_BY_TYPE: Record<Banner['type'], string> = {
  error: 'text-error',
  warning: 'text-warning',
  info: 'text-secondary'
};
const renderIcon = (type: Banner['type']) => {
  if (type === 'error') return <IcoClose16 color="error" className="min-w-[16px] max-md:mt-0.5" />;
  if (type === 'warning') return <IcoWarning16 color="warning" className="min-w-[16px] max-md:mt-0.5" />;
  return <IcoInfo16 className="min-w-[16px] max-md:mt-0.5" />;
};
const ErrorWarningSheet = t0 => {
  const $ = _c(6);
  const {
    errors,
    open,
    isOpen
  } = t0;
  let t1;
  if ($[0] !== errors || $[1] !== isOpen || $[2] !== open) {
    t1 = isOpen && <motion.div key="error-sheet" className="flex overflow-hidden relative z-popover flex-col w-[calc(100vw-32px)] rounded-lg md:w-[462px] border border-tertiary bg-primary" initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 10
    }}><div className="max-h-[200px] overflow-y-scroll [&>*:not(:last-child)]:border-b [&>*:not(:last-child)]:border-tertiary">{errors.map(item => <button key={`error-item-${item.nodeId}-${item.description.message}`} type="button" className="outline-none min-h-[32px] w-full flex flex-row gap-2 p-2 items-start md:items-center text-body-2 hover:bg-hover cursor-pointer transition-colors duration-200" onClick={() => open(item.nodeId)}>{renderIcon(item.type)}<span className={cx(["max-md:min-w-0 max-md:line-clamp-3 max-md:break-words max-md:text-left md:truncate", TEXT_COLOR_BY_TYPE[item.type]])} title={item.description.message}>{item.description.message}</span></button>)}</div></motion.div>;
    $[0] = errors;
    $[1] = isOpen;
    $[2] = open;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default ErrorWarningSheet;